import React from 'react'
import "./ProductPage.css"
import {ProductPageDesktop} from './ProductPageDesktop/ProductPageDesktop' 
import {ProductPageMobile} from './ProductPageMobile/ProductPageMobile'
import { useMediaQuery,useTheme } from '@mui/material'

export function ProductPage() {
  const theme=useTheme();
  const isMobile=useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
    {isMobile && <ProductPageMobile/> }
    {!isMobile && <ProductPageDesktop/> }
    </>
  )
}

 